import React from "react";
import "./AlphaGroupsComp.scss";
import alphaLogo from "../../../assets/images/AlphaLogoImg.png";
import futuresLogo from "../../../assets/images/FuturesLogoImg.png";
import marketsLogo from "../../../assets/images/MarketsLogoImg.png";
import primeLogo from "../../../assets/images/PrimeLogoImg.png";
import traderLogo from "../../../assets/images/TraderLogoImg.png";
import {ReactComponent as FuturesMockup} from "../../../assets/icons/FuturesMockup.svg";
import {ReactComponent as MarketsMockup} from "../../../assets/icons/MarketsMockup.svg";
import {ReactComponent as AlphaMockup} from "../../../assets/icons/AlphaGroupMockup.svg";
import {ReactComponent as PrimeMockup} from "../../../assets/icons/PrimeMockup.svg";
import {ReactComponent as TraderMockup} from "../../../assets/icons/TraderMockup.svg";
const AlphaGroupsComp = () => {
  const groupData = [
    {
      logo: alphaLogo,
      img: <AlphaMockup />,
      name: "Alpha Capital",
      desc: "Is our flagship proprietary virtual trading firm, where the focus is on leveraging your analytical skills to shape data-driven strategies. Our commitment to transparency, integrity, and support ensures you have the tools and environment to excel in your market evaluations.",
    },
    {
      logo: futuresLogo,
      img: <FuturesMockup />,
      name: "Alpha Futures",
      desc: "Takes proprietary futures virtual trading to the next level, offering a platform where market analyst can utilize advanced, in-house technology to generate precise and impactful insights. As a core part of Alpha Capital Group, Alpha Futures benefits from the same innovative infrastructure that defines our commitment to superior virtual trading experiences.",
    },
    {
      logo: marketsLogo,
      img: <MarketsMockup />,
      name: "ACG Markets",
      desc: "Our regulated broker licensed in the Seychelles, provides a secure and compliant environment for market participants. With a focus on regulatory excellence and competitive market access, Alpha Markets stands as a trusted gateway to global financial markets.",
    },
  ];
  const secondGroupData = [
    {
      logo: primeLogo,
      img: <PrimeMockup />,
      name: "Alpha Prime",
      desc: "Built on the legacy of Alpha Capital and Alpha Futures, designed for elite traders ready to push boundaries. With direct access to expert mentorship, institutional-grade resources, and a close-knit network of top UK prop talent, Alpha Prime is where ambition meets opportunity.",
    },
    {
      logo: traderLogo,
      img: <TraderMockup />,
      name: "Alpha Trader",
      note: "Coming Soon",
      desc: "Alpha Capital’s proprietary virtual trading platform. Alpha Trader is built specifically for analysts who demand precision and performance. Get access to advanced algorithmic tools, seamless TradingView integration, customizable features and more.",
    },
  ];

  return (
    <div className="alphaGroupsCompContainer">
      <div className="alphaGroupsCompWrapper">
        <div className="topSection">
          <p>The Alpha Group</p>
          <h2>Everything You Need Under One Roof</h2>
          <p>
            Alpha Capital Group is a unified financial ecosystem designed to empower market analyst and traders at every stage of their journey. Our group encompasses several specialized entities,
            each contributing to our mission of delivering excellence and innovation in the financial markets.
          </p>
        </div>
        <div className="midSection">
          {groupData.map((item, index) => (
            <div
              key={index}
              className="groupDataBox"
            >
              <div className="logos">
                <img
                  src={item.logo}
                  alt=""
                />
              </div>

              <h2>{item.name}</h2>
              <p>{item.desc}</p>

              <div className="images">
                <div className="image">{item.img}</div>
              </div>
            </div>
          ))}
        </div>
        <div className="lowerSection">
          {secondGroupData.map((item, index) => (
            <div
              key={index}
              className="groupDataBox"
            >
              <div className="logos">
                <img
                  src={item.logo}
                  alt=""
                />
              </div>
              <h2>
                {item.name.split(" ")[0]} <span>{item.name.split(" ").slice(1).join(" ")}</span>
              </h2>
              {item.note && <p className="note">{item.note}</p>}
              <p>{item.desc}</p>

              <div className="images">
                <div className="image">{item.img}</div>
              </div>
            </div>
          ))}
        </div>
        {/* <div className="bottomSection">
          <div className="bottomSecDesc">
            <h3>Coming soon</h3>
            <p>
              Alpha Trader will introduce a revolutionary virtual trading platform, custom-built with full TradingView integration, advanced charting tools, and a seamless execution panel. Developed
              entirely in-house, Alpha Trader represents the pinnacle of our technological innovation, designed to meet the evolving needs of our analyst and traders.
            </p>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default AlphaGroupsComp;
